"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.description.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _ChevronLeft = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function BackToButton(_a) {
  var to = _a.to,
    _b = _a.description,
    description = _b === void 0 ? null : _b,
    _c = _a.color,
    color = _c === void 0 ? '#696969' : _c;
  return (0, _jsxRuntime.jsx)(_reactRouterDom.Link, __assign({
    to: to
  }, {
    children: (0, _jsxRuntime.jsxs)("div", __assign({
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 40
      }
    }, {
      children: [(0, _jsxRuntime.jsx)("div", __assign({
        style: {
          width: 18,
          height: 18,
          backgroundColor: color,
          borderRadius: 30,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: 5
        }
      }, {
        children: (0, _jsxRuntime.jsx)(_ChevronLeft.default, {
          style: {
            color: 'white',
            fontSize: 15
          }
        })
      })), (0, _jsxRuntime.jsxs)(_material.Typography, __assign({
        variant: 'overline',
        style: {
          color: color
        }
      }, {
        children: ["Back", description != null ? ' to ' + description : '']
      }))]
    }))
  }));
}
BackToButton.propTypes = {
  to: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  color: _propTypes.default.string
};
var _default = BackToButton;
exports.default = _default;